import {
  filter,
  tap,
  ignoreElements,
  switchMap,
  mergeMap,
  catchError,
} from 'rxjs/operators'
import {of, concat, from} from 'rxjs'
import {Epic} from 'redux-observable'
import {RootState, AppActions} from 'app/rootReducer'
import {MonolithService} from 'services/api'
import Toast from 'components/Basic/Toast'
import {endpointsActions} from './endpointsSlice'
import {i18n} from 'i18n'

const {t} = i18n

const getAssociatedUserEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = action$ =>
  action$.pipe(
    filter(endpointsActions.getAssociatedUsers.match),
    switchMap(({payload}) =>
      from(MonolithService.getAssociatedUsers(payload)).pipe(
        mergeMap(({data}) => [
          endpointsActions.getAssociatedUsersSuccess(data),
        ]),
        catchError((message: string) =>
          concat(of(endpointsActions.getAssociatedUsersFailure(message))),
        ),
      ),
    ),
  )

const getAssociatedUserFailureEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = action$ =>
  action$.pipe(
    filter(endpointsActions.getAssociatedUsersFailure.match),
    tap(({payload: message}) => Toast({message, type: 'error'})),
    ignoreElements(),
  )

const getDiagnosticResultEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = action$ =>
  action$.pipe(
    filter(endpointsActions.getDiagnosticResult.match),
    switchMap(({payload}) =>
      from(MonolithService.getDiagnosticResult(payload)).pipe(
        mergeMap(({data}) => [
          endpointsActions.getDiagnosticResultSuccess(data),
        ]),
        catchError((message: string) =>
          concat(of(endpointsActions.getDiagnosticResultFailure(message))),
        ),
      ),
    ),
  )

const getDiagnosticResultFailureEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = action$ =>
  action$.pipe(
    filter(endpointsActions.getDiagnosticResultFailure.match),
    tap(({payload: message}) => Toast({message, type: 'error'})),
    ignoreElements(),
  )

const toggleEndpointEpic: Epic<AppActions, AppActions, RootState> = action$ =>
  action$.pipe(
    filter(endpointsActions.toggleEndpoint.match),
    switchMap(({payload}) =>
      from(MonolithService.toggleEndpoint(payload)).pipe(
        mergeMap(() => [
          endpointsActions.toggleEndpointSuccess(
            payload?.disableOption === true
              ? t('endpoints:ENDPOINT_DISABLED_TOAST_MESSAGE')
              : payload?.disableOption === false
              ? t('endpoints:ENDPOINT_ENABLED_TOAST_MESSAGE')
              : payload?.debugMode === true
              ? t('endpoints:ENABLE_DEBUG_MODE_REQ_SENT_MESSAGE')
              : t('endpoints:DISABLE_DEBUG_MODE_REQ_SENT_MESSAGE'),
          ),
        ]),
        catchError((message: string) =>
          concat(of(endpointsActions.toggleEndpointFailure(message))),
        ),
      ),
    ),
  )

const toggleEndpointSuccessEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = action$ =>
  action$.pipe(
    filter(endpointsActions.toggleEndpointSuccess.match),
    tap(({payload: message}) => Toast({message, type: 'success'})),
    ignoreElements(),
  )

const toggleEndpointFailureEpic: Epic<
  AppActions,
  AppActions,
  RootState
> = action$ =>
  action$.pipe(
    filter(endpointsActions.toggleEndpointFailure.match),
    tap(({payload: message}) => Toast({message, type: 'error'})),
    ignoreElements(),
  )

export const endpointsEpics = [
  toggleEndpointEpic,
  toggleEndpointFailureEpic,
  getAssociatedUserEpic,
  getAssociatedUserFailureEpic,
  getDiagnosticResultFailureEpic,
  getDiagnosticResultEpic,
  toggleEndpointSuccessEpic,
]
